import { MailingId } from 'modules/mailing/types/mailing-interface'
import { NEWSLETTERS_API } from 'modules/newsletters/single/api/newsletters-api'
import { NewsletterId } from 'modules/newsletters/single/types/newsletter-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'

export const useCancelSplitTest = () => {
  const { fetcher, isFetching } = useFetch<RequestMethodsEnum.post>({
    method: RequestMethodsEnum.post,
  })
  return {
    cancelSplitTest: (newsletterId: NewsletterId, mailingId: MailingId) =>
      fetcher(`${NEWSLETTERS_API}/${newsletterId}/split-test/cancel-with-mailing/${mailingId}`),
    isFetching,
  }
}
